import ko from "knockout";

export default class Settings {
    parent: any;

    sendContractAfterIdUpload: KnockoutObservable<boolean>;
    sendContractAfterIdApproved: KnockoutObservable<boolean>;
    
    constructor(model: any, parent: any) {
        this.parent = parent;

        this.sendContractAfterIdUpload = ko.observable<boolean>(false);
        this.sendContractAfterIdApproved = ko.observable<boolean>(false);

        this.sendContractAfterIdApproved.subscribe((newValue) => {
            if(newValue) {
                this.sendContractAfterIdUpload(false);
            }
        })

        this.sendContractAfterIdUpload.subscribe((newValue) => {
            if(newValue) {
                this.sendContractAfterIdApproved(false);
            }
        })
    }
}
